﻿$.fn.dxCtrlVisuHebergementConfig = function custom_dxCtrlVisuHebergementConfig(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlvisuhebergementconfig dx-ctrl");
        this.createInstance(new cdxCtrlVisuHebergementConfig(this, option));
    }
    return this;
}

window.cdxCtrlVisuHebergementConfig = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.height == 'undefined') option.height = 22

    var dx = null;
    function mConstruit() {
        container.empty();
        //container.css("color", theme.color)
        if (option.value.nb_grand_lit == 0 && option.value.nb_petit_lit == 0) {
            container.text("(aucun lit)")
        } else {
            //if (option.value.nb_grand_lit > 0) {
            //    var $span = $("<span style='font-size:100%;'>" + option.value.nb_grand_lit + "</span>").appendTo(container)
            //    $("<i class='fas fa-bed' style='position:relative' title='grand lit'><i class='fas fa-people-arrows dx-theme-accent-as-text-color' style='position:absolute;right:0;bottom:0;font-size:80%;'></i></i>").appendTo(container)
            //}
            //if (option.value.nb_petit_lit > 0) {
            //    var $span = $("<span style='font-size:100%;'>" + option.value.nb_petit_lit + "</span>").appendTo(container)
            //    $("<i class='fas fa-bed' style='position:relative' title='petit lit'><i class='fas fachild dx-theme-accent-as-text-color' style='position:absolute;right:0;bottom:0;font-size:80%;'></i></i>").appendTo(container)
            //}
            var title = ""
            if (option.value.nb_grand_lit > 0) {
                var $span = $("<span style='font-size:200%;'><b>" + option.value.nb_grand_lit + "</b><i class='fafa-grand-lit'></i></span>").appendTo(container)
                if (option.colorImage) $Icon.css("color", option.colorImage)
                title = option.value.nb_grand_lit + " grand lit"
            }

           if (option.value.nb_petit_lit > 0) {
               var $span = $("<span style='font-size:200%;'><b>" + option.value.nb_petit_lit + "</b><i class='fafa-petit-lit'></i></span>").appendTo(container)
                if (option.colorImage) $Icon.css("color", option.colorImage)
                title += (title.length > 0 ? "<br/>" : "") + option.value.nb_petit_lit + " petit lit"
            }
            container.attr("title",title)
        }
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}